var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pop-up-main',{attrs:{"title":"欢迎！"},on:{"closepopup":function($event){return _vm.$emit('closepopup')}}},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("nay")]),_c('p',[_vm._v("快乐听歌鸭！~")])])])}
var staticRenderFns = []

export { render, staticRenderFns }